'use client';

import clsx from 'clsx';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import Icons from '@/components/layout/components/[default]/footer/social-media/icons';
import SmartOffer from '@/components/shared/components/smart-offers';

import { useSmartOfferStore } from '@/store/smart-offer.store';

import { DATA_CY_FOOTER_POLICY } from '@/constant/cypress';
import { pageLevelLocalization } from '@/constant/localization';

const { layout: layoutLocalization } = pageLevelLocalization;

export default function Policy() {
  const { showInLineSmartOffer } = useSmartOfferStore();
  const zhaketCloudUrl = process.env.NEXT_PUBLIC_ZHAKET_CLOUD_URL;

  const handleButtonClick = () => {
    window.open(zhaketCloudUrl, '_blank', 'noopener,noreferrer');
  };
  return (
    <Container
      data-cy={DATA_CY_FOOTER_POLICY}
      center
      className={clsx(
        showInLineSmartOffer && 'mb-22!',
        'flex-col pt-6 pb-[10px] md:justify-between',
      )}
    >
      <Container className='flex flex-col flex-col-reverse items-center md:flex-row'>
        <Text
          center
          medium
          size={SIZE_ENUM.SM}
          className='font-light tracking-tighter text-[#7E899B]'
        >
          {layoutLocalization.policy}
        </Text>
        <div className='mx-2 hidden h-4 w-[1px] bg-[#E1E3E5] md:inline'></div>
        <Container className='flex items-center'>
          <Text center size={SIZE_ENUM.SM} className='font-light text-[#7E899B]'>
            {layoutLocalization.hostingOnDedicatedServers}
          </Text>
          <Button
            className='bg-transparent px-0.5! text-sm text-[#FF9606] hover:text-[#EB8800]'
            onClick={handleButtonClick}
          >
            {layoutLocalization.zhaketCloud}
          </Button>
        </Container>
      </Container>
      <Container className='mt-2'>
        <Icons />
      </Container>
      <SmartOffer />
    </Container>
  );
}
